module.exports = __webpack_public_path__ + "img/wallpaper.01c0c9ff.jpg";